import { Pipe, PipeTransform } from '@angular/core';
import { KeyValue } from '../models';

@Pipe({
	name: 'enumToArray',
	standalone: true
})
export class EnumToArrayPipe implements PipeTransform {
	transform(data: object, useNew: boolean = false) {

		if (useNew) {
			return Object.entries(data)
				.filter(([key]) => isNaN(Number(key))) // Filter out numeric keys if it's a numeric enum
				.map(([key, value]) => ({
					key,
					value
				}));
		}

		let item: KeyValue[] = [];
		Object.keys(data).forEach((key) => {
			item.push({
				key: key,
				value: data[key]
			});
		});
		item = item.slice(item.length / 2);
		item.pop();
		return item;


	}
}
